module.exports = __webpack_public_path__ + "img/progress_027.3c117de9.png";